/*
	При необходимости сохраняем конфиг в LocalStorage:
	— не записываем пустой массив (избегаем гонки до setConfiguration);
	— не перезаписываем только если в LS уже есть непустой валидный массив.
*/

const localStorageHasNonEmptyModulesConfig = (raw: string | null): boolean => {
	if (!raw) return false;
	try {
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) && parsed.length > 0;
	} catch {
		return false;
	}
};

export const saveConfigInLocalStorageIfNeeded = (appModulesConfig: unknown) => {
	try {
		if (typeof window === "undefined") return;
		const nextArr = Array.isArray(appModulesConfig) ? appModulesConfig : [];
		if (nextArr.length === 0) return;

		const prev = localStorage.getItem("modulesConfig");
		if (localStorageHasNonEmptyModulesConfig(prev)) return;

		localStorage.setItem("modulesConfig", JSON.stringify(nextArr));
	} catch (err) {
		console.log("Cannot persist modulesConfig to localStorage", err);
	}
};
